<template>
  <span v-if="isVisible" class="group-status-chip" :class="`group-status-chip--${status.tone}`">{{ status.label }}</span>
</template>

<script>
import { describeGroupStatus, hasStatusChip } from '../groupStatus'

export default {
  name: 'GroupStatusChip',
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    status () {
      return describeGroupStatus(this.group)
    },
    isVisible () {
      return hasStatusChip(this.group)
    }
  }
}
</script>

<style scoped>
.group-status-chip {
  display: inline-block;
  min-width: var(--chip-width);
  padding: 3px 10px;
  border-radius: var(--radius);
  font-size: var(--font-small);
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
}

.group-status-chip--weighed {
  color: var(--brand-green-text);
  background-color: var(--brand-green-soft);
}

.group-status-chip--short {
  color: var(--danger-text);
  background-color: var(--danger-soft);
}

.group-status-chip--raw-portioned {
  color: var(--text-body);
  background-color: var(--neutral-soft);
}

.group-status-chip--not-summing {
  font-weight: 400;
  color: var(--text-muted);
  background-color: var(--neutral-soft);
}
</style>
